import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import styles from './StandardContainer.module.scss'

export const StandardContainer = ({ children, className }) => {
  const classes = classnames(
    styles.standardContainer,
    { [`${className}`]: className },
  )

  return (
    <div className={classes}>
      {children}
    </div>
  )
}

StandardContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
